const tableBodyCellStyles = (theme, { error, row, column, isRowOpen }) => {
  return {
    error: {
      padding: '8px',
      borderRadius: '8px',
      border: '1px solid red',
      background: '#fff',
      width: '150px',
    },
    cell: {
      boxSizing: 'border-box',
      minWidth: column?.cellMinWidth || '60px',
      maxWidth: column?.cellMaxWidth,
      width: column?.cellWidth,

      backgroundColor: error
        ? 'rgba(224, 23, 23, 0.1)'
        : row?.totalRow
          ? 'rgba(93, 175, 239, 0.20)'
          : null,
      cursor: error ? 'pointer' : null,
      padding: column?.paddingBodyCell || 1,
      position: 'relative',

      '&.MuiTableCell-root': {
        '.MuiBox-root': {
          margin: '0',
        },
        [theme.breakpoints.down('sm')]: {
          border: 'none !important',
        },
      },
      [theme.breakpoints.down('sm')]: {
        padding: '4px 0 4px 0',
      },
    },
    cellContainer: {
      margin: '0 auto',
      height: `calc(56px - 16px)`,
      display: 'flex',
      justifyContent: column?.justifyContent || 'center',
      alignItems: 'center',
    },
    contentText: {
      textAlign: column?.textAlign || 'center',
      padding: column?.padding || null,
      display: '-webkit-box',
      WebkitLineClamp: '2',
      WebkitBoxOrient: 'vertical',
      overflow: 'hidden',
      fontSize: '14px',
      fontWeight: navigator?.userAgent.includes('Firefox') ? '400' : '500',
      ...(row?.totalRow ? { fontWeight: 600, fontSize: '20px' } : {}),
    },

    miniLastRowCell: {
      width: '100% !important',
      display: 'flex',
      justifyContent: 'flex-end',
      paddingRight: '10px',
    },
  }
}

export default tableBodyCellStyles
